import { render, staticRenderFns } from "./StartupRegisteredTreeView.vue?vue&type=template&id=4ef670ad&scoped=true"
import script from "./StartupRegisteredTreeView.vue?vue&type=script&lang=js"
export * from "./StartupRegisteredTreeView.vue?vue&type=script&lang=js"
import style0 from "./StartupRegisteredTreeView.vue?vue&type=style&index=0&id=4ef670ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef670ad",
  null
  
)

export default component.exports